<template lang="pug">
	.game-time(:class="{ 'is-overtime': isOvertime }")
		span.time-minutes {{ minutes | paddedTime }}
		span.time-overtime(v-if="isOvertime") +{{ overtimeMinutes }}
		span.time-divider :
		span.time-seconds {{ seconds | paddedTime }}
		.button.is-small(v-if="editable", @click="$emit('edit')")
			b-icon(icon="pen")
</template>

<script>
import phaseMixin from '../mixins/phaseMixin'
import gameTimeMixin from '../mixins/gameTimeMixin'

export default {
	mixins: [
		phaseMixin,
		gameTimeMixin
	],
	props: {
		phase: Object,
		editable: Boolean
	},
	data: () => {
		return {
			timer: null,

			minutes: 0,
			overtimeMinutes: 0,
			isOvertime: false,
			seconds: 0,
			start: null
		}
	},
	mounted () {
		if (this.isRunning) {
			this.calculateTimes()
			this.startClockTimer()
		}
	},
	beforeDestroy () {
		this.clearClockTimer()
	},
	watch: {
		isRunning: {
			handler: function (newValue, oldValue) {
				if (newValue !== oldValue) {
					if (newValue === false) {
						this.clearClockTimer()
					} else {
						this.calculateTimes()
						this.startClockTimer()
					}
				}
			}
		}
	},
	computed: {
		isRunning () {
			return this.isPhaseTimed(this.phase.key)
		}
	},
	methods: {
		startClockTimer () {
			this.calculateTimes()
			if (!this.timer) {
				this.timer = window.setInterval(this.calculateTimes.bind(this), 1000)
			}
		},
		clearClockTimer () {
			if (this.timer) {
				window.clearInterval(this.timer)
				this.timer = null
			}
		},
		calculateTimes () {
			var time = this.getGameTimeForPhase(this.phase)
			this.minutes = time.minutes
			this.seconds = time.seconds
			this.overtimeMinutes = time.overtimeMinutes
			this.isOvertime = time.isOvertime
			this.$emit('tick', time)
		}
	},
	filters: {
		paddedTime (value) {
			var v = Number.parseInt(value)
			if (v < 10) {
				return '0' + v
			} else {
				return v
			}
		}
	}
}
</script>

<style lang="scss" scoped>
	@import '@/assets/scss/bulma-variables.scss';
	.game-time {
		font-weight: bold;
		font-size: 1.2em;
		position: relative;

		&.is-overtime {
			.time-seconds,
			.time-divider {
				color: $secondary

			}
		}

		.button {
			display: none;
			position: absolute;
			top: 0;
			right: 0
		}

		&:hover {
			.button {
				display: block;
			}
		}
	}
	.time-overtime {
		padding-left: 0.1em;
		color: $secondary
	}

</style>
